import { render, staticRenderFns } from "./taohs.vue?vue&type=template&id=63fbe05b&scoped=true&"
import script from "./taohs.vue?vue&type=script&lang=js&"
export * from "./taohs.vue?vue&type=script&lang=js&"
import style0 from "./taohs.vue?vue&type=style&index=0&id=63fbe05b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbe05b",
  null
  
)

export default component.exports